










import { Vue, Component } from 'vue-property-decorator';
import ProgramacionInforme from '@/pantallas/ProgramacionInforme/ProgramacionInforme.vue';

@Component({
  components: { ProgramacionInforme },
})
export default class ProgramacionInformePantalla extends Vue {}
